import {NodeContext} from '../../../@polygonjs/polygonjs/src/engine/poly/NodeContext';
export const DOCUMENT_NODES_NOT_FETCHED: Record<NodeContext, string[]> = {
	[NodeContext.ANIM]: [],
	[NodeContext.AUDIO]: [],
	// [NodeContext.CAD]: [],
	// [NodeContext.COP]: 'Textures',
	// [NodeContext.CSG]: [],
	[NodeContext.EVENT]: [],
	// [NodeContext.SOP]: 'Geometry',
	// [NodeContext.GL]: 'Shaders',
	// [NodeContext.MAT]: 'Materials',
	[NodeContext.OBJ]: [],
	[NodeContext.POST]: [],
	[NodeContext.ROP]: [],
	[NodeContext.JS]: [],
	[NodeContext.MANAGER]: [],
	[NodeContext.COP]: ['sdfblur'],
	[NodeContext.GL]: [
		'asin',
		'add',
		'abs',
		'and',
		'atan',
		'booltoint',
		'ceil',
		'clamp',
		'cos',
		'degrees',
		'divide',
		'exp',
		'distance',
		'dot',
		'fit',
		'exp2',
		'faceforward',
		'neighbourdensity',
		'fitto01',
		'fitfrom01',
		'fitfrom01tovariance',
		'floattoint',
		'floattovec2',
		'floattovec3',
		'floattovec4',
		'floor',
		'fract',
		'impostoruv',
		'inttobool',
		'inttofloat',
		'inversesqrt',
		'log',
		'log2',
		'min',
		'max',
		'mult',
		'mod',
		'normalize',
		'oklabtorgb',
		'or',
		'quatslerp',
		'pow',
		'radians',
		'sign',
		'rgbtooklab',
		'reflect',
		'smoothstep',
		'sin',
		'acos',
		'step',
		'tan',
		'sqrt',
		'subtract',
		'uvtooklab',
		'toworldspace',
		'vec2tovec3',
		'vec3tovec2',
		'vec3tofloat',
		'vec4tovec3',
		'vec3tovec4',
		'vec4tofloat',
		'vec2tofloat',
	],
	[NodeContext.MAT]: ['envmap', 'color', 'meshdepthbuilder', 'meshdepth', 'meshdistance', 'meshdistancebuilder'],
	[NodeContext.SOP]: ['animationcopy', 'operationscomposer', 'facet', 'physicsjoints'],
};
